// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__I99lQ","alertIcon":"ConfirmModal_alertIcon__2WLfa"};